import React from 'react';
import pic28 from '../../assets/pic28.png'
import './select.css'


const Select = (props) => {
      const options = [props.select1, props.select2, props.select3].filter(Boolean);
    return ( 
        <fieldset className='container-selecttt'>
            
                    <h2 className='title-selecttt'>{props.title}</h2>
                     <div className="select-wrapper2">

                                        <img src={pic28} className="arrow-icon2" alt="arrow" />
                                   <select
                                        className="input-search2 select-style2"
                                              value={props.value}
                                             onChange={props.onChange}
                                        >
                                        <option value="">Sort by</option>
                        {options.map((opt, index) => (
                                    <option key={index} value={opt}>
                                    {opt}
                                    </option>
                                ))}
                                        </select>
                    </div>
        </fieldset>
     );
}
 
export default Select;